'use strict';

var React = require('react');
var designSystemTheme = require('@sravni/design-system-theme');
var Controlled = require('./Controlled.js');
var Uncontrolled = require('./Uncontrolled.js');
var Context = require('./Context.js');

/**
 * @description Theme context provider component.
 *
 * @component
 * @example
 * ```jsx
 * <ThemeProvider initialTheme="lager">content</ThemeProvider>
 * ```
 */
function ThemeProvider(props) {
    const { initialTheme, children } = props;
    const isControlled = typeof initialTheme === 'undefined';
    if (isControlled) {
        const { theme, onChange } = props;
        return (React.createElement(Controlled.ControlledThemeProvider, { theme: theme, onChange: onChange }, children));
    }
    return (React.createElement(Uncontrolled.UncontrolledThemeProvider, { initialTheme: initialTheme || designSystemTheme.ThemeName.lager }, children));
}

exports.ThemeContext = Context.ThemeContext;
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=index.js.map
